import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
} from 'react-router-dom';

import { wrapCreateBrowserRouter } from '@sentry/react';

// Default Connexion Pages
import Login from '@/pages/Login';
import ForgotPassword from '@/pages/ForgotPassword';

//  Main Protected Layout
import ProtectedLayout from '@/layouts/ProtectedLayout';
import RouterErrorBoundary from '@/components/RouterErrorBoundary';

export interface ISubRoute {
  element: React.ReactElement;
  path: string;
  title?: string | React.ReactElement;
  hideHeader?: boolean;
  isPage?: boolean;
  isTab?: boolean;
}

export interface IRoute {
  element: React.ReactElement;
  path: string;
  title?: string | React.ReactElement;
  icon?: React.ReactElement;
  menuKeys?: string[];
  hideInMenu?: boolean;
  hideHeader?: boolean;
  routes?: ISubRoute[];
}

export type IRoutes = IRoute[];
export interface MenuDisplayConditions {
  key: string;
  display: boolean;
}

export const checkIfDisplayRoute = (
  route: string,
  menuConditions: MenuDisplayConditions[],
) => {
  const conditioned = menuConditions.find(
    (condition) => route === condition.key,
  );

  if (conditioned) {
    return conditioned.display;
  }
  return true;
};

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

//// Router already configured to configure

export const routing = (
  routesList: IRoutes,
  mainUrl: string,
  menuConditions: MenuDisplayConditions[],
) =>
  sentryCreateBrowserRouter(
    createRoutesFromElements(
      <Route path="/" ErrorBoundary={RouterErrorBoundary}>
        <Route path="/login" element={<Login {...{ main: mainUrl }} />} />
        <Route
          path="/login/reset-password/:token/:email"
          element={<ForgotPassword />}
        />
        <Route path="/" element={<Navigate to={mainUrl || '/'} replace />} />
        <Route path="/*" element={<Navigate to={mainUrl || '/'} replace />} />
        <Route
          path="/"
          element={
            <ProtectedLayout {...{ menu: routesList, menuConditions }} />
          }
        >
          {routesList
            .filter((item) => checkIfDisplayRoute(item.path, menuConditions))
            .map((route) => (
              <Route key={route.path} path={route.path} element={route.element}>
                {route.routes?.length &&
                  route.routes
                    .filter((item) =>
                      checkIfDisplayRoute(item.path, menuConditions),
                    )
                    .map((tab) => (
                      <Route
                        key={tab.path}
                        path={tab.path}
                        element={tab.element}
                      />
                    ))}
              </Route>
            ))}
        </Route>
      </Route>,
    ),
    { basename: import.meta.env.BASE_URL },
  );
